module.exports = __webpack_public_path__ + "img/22-2@2x.810808a1.png";